import { PayloadAction } from "@reduxjs/toolkit";
import { call, CallEffect, put, PutEffect } from "redux-saga/effects";
import { auth } from "../../../config/firebase";
import { deleteDocument } from "../api/documentsApi";
import { deleteDocumentError, deleteDocumentSuccess } from "./documentsSlice";

export function* handleDeleteDocument(
  action: PayloadAction<{ documentId: string; filename: string }>
): Generator<CallEffect | PutEffect, void, any> {
  try {
    if (!auth.currentUser) {
      throw new Error("User not authenticated");
    }

    yield call(
      deleteDocument,
      auth.currentUser.uid,
      action.payload.documentId,
      action.payload.filename
    );

    yield put(deleteDocumentSuccess({ documentId: action.payload.documentId }));
  } catch (error) {
    yield put(
      deleteDocumentError(
        error instanceof Error ? error.message : "Deletion failed"
      )
    );
  }
}
